import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Breadcrumb from "../../components/breadcrumb";
// import Postjob from "./Postjob";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import PostCard from "./PostCard";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";

PostJobs.propTypes = {};

function PostJobs(props) {

    const [isShowMobile, setShowMobile] = useState(false);

    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);
    const module = localStorage.getItem('Module')
    return (
        <>
            {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="manageJobs" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="manageJobs" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader clname="manageJobs" handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader clname="manageJobs" handleMobile={handleMobile} /> :
                            <NonLoginHeader clname="manageJobs" handleMobile={handleMobile} />}
            {/* <Breadcrumb title="Approval Process" className="breadcrumb-section" /> */}
            {/* <Postjob className="" /> */}

            <div className="pt-70">
            <PostCard />
            {/* <Footer /> */}
            <Gotop />
            </div>
        </>
    );
}

export default PostJobs;
